import React, {useEffect, useState} from 'react';
import {Field, Form, Formik} from 'formik';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import HighlightOff from '@material-ui/icons/HighlightOff';
import Edit from '@material-ui/icons/Edit';
import Trash from '@material-ui/icons/Delete';
import useRequest from '../../../../../../../_metronic/_helpers/useRequest';
import useConfig from '../../../../../../../_metronic/_helpers/useConfig';
import {
  API_CREATE_VISIT_SHEET_CONTENT_TEXT,
  API_UPDATE_VISIT_SHEET_CONTENT_TEXT,
} from '../../../../../../constants/api';

const Text = ({
  data,
  edit,
  parentClasses,
  label,
  required,
  labelSuffix,
  classes,
  disabled,
  activeContent,
  setContent,
  setReady,
  handlerSetLayout,
  rank,
  setNewModule,
}) => {
  const [object, setObject] = useState(
    data ? activeContent[data.table_name].find((x) => x.id === data.id) : null
  );
  const [modify, setModify] = useState(!data);
  const [handleRequest] = useRequest();
  const config = useConfig();

  useEffect(() => {
    setObject(data ? activeContent[data.table_name].find((x) => x.id === data.id) : null);
  }, [activeContent, data]);

  const handleSubmit = (values, formikBag) => {
    setReady(false);
    if (data) {
      handleRequest(
        'put',
        API_UPDATE_VISIT_SHEET_CONTENT_TEXT(activeContent.id, data.id),
        values,
        config,
        (dataRes, status) => {
          if (status === 'Done') {
            setContent(dataRes);
            setModify(false);
            setReady(true);
          } else if (status === 'Error') {
            setModify(false);
            setReady(true);
          }
        }
      );
    } else {
      handleRequest(
        'post',
        API_CREATE_VISIT_SHEET_CONTENT_TEXT(activeContent.id),
        values,
        config,
        (dataRes, status) => {
          if (status === 'Done') {
            const layout = activeContent?.layout ? JSON.parse(activeContent.layout) : {};
            layout[rank] = [
              {
                sortable_item: 'text',
                table_name: 'visit_sheet_content_has_texts',
                id: dataRes.id,
              },
            ];
            handlerSetLayout(layout);
            setModify(false);
            setReady(true);
          } else if (status === 'Error') {
            setModify(false);
            setReady(true);
          }
        }
      );
    }
  };

  const handleDelete = () => {
    if (data) {
      handleRequest(
        'delete',
        API_UPDATE_VISIT_SHEET_CONTENT_TEXT(activeContent.id, data.id),
        {},
        config,
        (dataRes, status) => {
          if (status === 'Done') {
            const layout = activeContent?.layout ? JSON.parse(activeContent.layout) : {};
            delete layout[rank];
            handlerSetLayout(layout);
            setModify(false);
            setReady(true);
          } else if (status === 'Error') {
            setModify(false);
            setReady(true);
          }
        }
      );
    }
  };

  return edit ? (
    <Formik
      initialValues={{text: object?.paragraph || ''}}
      onSubmit={handleSubmit}
      validateOnMount={false}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({handleSubmit, ...subProps}) => (
        <Form className="form fv-plugins-bootstrap fv-plugins-framework" id="kt_form">
          <div className={'form-group fv-plugins-icon-container ' + parentClasses}>
            {label && (
              <div className="d-flex justify-content-between mt-n5">
                <label className="font-size-h6 text-dark pt-5">
                  {label}
                  {!modify && (
                    <>
                      <Edit
                        fontSize="medium"
                        className="mx-5"
                        onClick={() => setModify(true)}
                      />
                      <Trash fontSize="medium" htmlColor="red" onClick={handleDelete} />
                    </>
                  )}
                </label>
                {labelSuffix}
              </div>
            )}
            <div className="w-100 d-flex">
              {modify ? (
                <Field
                  onChange={subProps.handleChange}
                  name={'text'}
                  component="textarea"
                  type="text"
                  className={`form-control form-control-solid py-5 px-6 ${classes}`}
                  style={{resize: 'vertical'}}
                  disabled={disabled}
                />
              ) : (
                <p style={{whiteSpace: 'pre-wrap'}}>{object?.paragraph}</p>
              )}
              <div className="d-flex align-items-center px-2" style={{gap: 10}}>
                {modify && (
                  <>
                    <CheckCircleOutline
                      color="primary"
                      fontSize="large"
                      onClick={handleSubmit}
                    />
                    <HighlightOff
                      color="error"
                      fontSize="large"
                      onClick={() => {
                        setNewModule();
                        setModify(false);
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  ) : (
    <p style={{whiteSpace: 'pre-wrap'}}>{object?.paragraph}</p>
  );
};

export default Text;
